// removed by extract-text-webpack-plugin
module.exports = {"custom-slider":"index-module__custom-slider___BMA9P","customSlider":"index-module__custom-slider___BMA9P","slick-arrow":"index-module__slick-arrow___hJeV9","slickArrow":"index-module__slick-arrow___hJeV9","slick-next":"index-module__slick-next___30--u","slickNext":"index-module__slick-next___30--u"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/pages/home-V2/members-slider/index.module.scss
// module id = 1736
// module chunks = 146